import "./NoInternetComponent.scss";
import {motion} from "framer-motion";
import ChipComponent from "@/components/ui/ChipComponent.tsx";
import HeadingComponent from "@/components/common-components/heading/HeadingComponent.tsx";
import React, {useEffect, useState} from "react";
import {ImageConfig} from "@/constants";
import FloatingIconsRendererComponent
    from "@/components/common-components/floating-icons-renderer/FloatingIconsRendererComponent.tsx";
import UserAvatarComponent from "@/components/common-components/user-avatar/UserAvatarComponent.tsx";
import FooterComponent from "@/components/common-components/footer/FooterComponent.tsx";
import {Button} from "@/components/ui/button.tsx";


const NoInternetComponent = (props: React.PropsWithChildren<any>) => {

    const [isOffline, setIsOffline] = useState(false);

    useEffect(() => {
        const handleOnline = () => {
            setIsOffline(false);
        };

        const handleOffline = () => {
            setIsOffline(true);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        // Clean up event listeners when the component unmounts
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    const retryConnection = () => {
        window.location.reload();
    }

    return (
        <>
            {isOffline ?
                <div
                    className="flex flex-col min-h-screen bg-[#0a0a0a] text-white relative overflow-hidden on-boarding-layout">
                    {/* Header */}
                    <header className="flex justify-between items-center p-4 border-b border-[#2a2a2a] relative z-10">
                        <ImageConfig.MediumLogo/>
                        <UserAvatarComponent/>
                    </header>
                    <div className="min-h-[calc(100vh-140px)] w-full overflow-hidden flex items-center justify-center">
                        <motion.main

                            initial={{opacity: 0, scale: 0.95, filter: "blur(0px)"}}
                            whileInView={{opacity: 1, scale: 1}}
                            transition={{duration: 0.3, ease: "easeInOut"}}
                            className="flex flex-col items-center justify-center w-full py-8"
                        >
                            <ChipComponent text={'No Internet'}/>
                            <HeadingComponent>
                                <span className="text-primary">Uh-oh!</span> You’re Offline It looks <br/> like your
                                connection is lost.
                            </HeadingComponent>
                            <div className="text-secondary-foreground mb-8 mt-[-18px] text-[18px] text-center">
                                It seems like you’re not connected to the internet.<br/><span
                                className={'text-secondary'}> Check your connection and try again!</span>
                            </div>
                            <motion.div
                                initial={{opacity: 0, y: 20}}
                                animate={{opacity: 1, y: 0}}
                                exit={{opacity: 0, y: -20}}
                                transition={{duration: 0.4}}
                                className="flex justify-center"
                            >
                                <Button
                                    onClick={retryConnection}
                                >
                                    <span>Refresh Page</span>
                                </Button>
                            </motion.div>
                        </motion.main>
                    </div>
                    <FloatingIconsRendererComponent/>
                    {/* Footer */}
                    <FooterComponent/>
                </div> : props.children}
        </>
    );

};

export default NoInternetComponent;
